import shippingPdfPricesReducer from './shippingPdfPricesSlice';
import { combineReducers } from '@reduxjs/toolkit';
import { loginReducer } from "./LoginReducer";
import { errorReducer } from "./ErrorReducer"; 
import { formatDIReducer } from "./FormatDIReducer"; 
import filtersPurchaseDeliveryReducer from './filtersPurchaseDeliverySlice'; 
import filtersPurchaseSignatureReducer from './filtersPurchaseSignatureSlice'; 
import filtersTicketsReducer from './filtersTicketsSlice.jsx'; 
import filtersVehiclesReducer from './filtersVehiclesSlice.jsx'; 
import filtersVehiclesTrailersReducer from './filtersVehiclesTrailersSlice.jsx';
import filtersStoresReducer from './filtersStoresSlice.jsx'; 
import filtersArticlesReducer from './filtersArticlesSlice.jsx'; 
import filtersEmployeesReducer from './filtersEmployeesSlice.jsx'; 
import filtersDriversReducer from './filtersDriversSlice.jsx'; 
import filtersShippingsReducer from './filtersShippingsSlice.jsx';
import filtersRegistersReducer from './filtersRegistersSlice.jsx';
import filtersContractsReducer from './filtersContractsSlice.jsx';
import filtersCNTReducer from './filtersNTSlice.jsx';
import filtersSHEETReducer from './filtersSHEETSlice.jsx';
import filtersFormDIReducer from './filtersFormDISlice'; 
import filtersReceivedEmailsReducer from './filtersReceivedEmailsSlice'; 
import filtersSentEmailsReducer from './filtersSentEmailsSlice'; 
import filtersSentInicidentssReducer from './filtersSentInicidentsSlice'; 

import paginationPurchaseDeliveryReducer from './paginationPurchaseDeliverySlice';
import paginationSignatureReducer from './paginationPurchaseSignatureSlice';
import paginationTicketsReducer from './paginationTicketsSlice';
import paginationVehiclesReducer from './paginationVehiclesSlice';
import paginationVehiclesTrailersReducer from './paginationVehiclesTrailersSlice';
import paginationStoresReducer from './paginationStoresSlice';
import paginationArticlesReducer from './paginationArticlesSlice';
import paginationEmployeesReducer from './paginationEmployeesSlice';
import paginationDriversReducer from './paginationDriversSlice';
import paginationShippingsReducer from './paginationShippingsSlice';
import paginationRegistersReducer from './paginationRegistersSlice';
import paginationContractsReducer from './paginationContractsSlice';
import paginationCNTReducer from './paginationNTsSlice';
import paginationFormDIReducer from './paginationFormDISlice';
import paginationSHEETReducer from './paginationSHEETSlice';
import paginationReceivedEmailsReducer from './paginationReceivedEmailsSlice';
import paginationSentEmailsReducer from './paginationSentEmailsSlice';
import paginationSentIncidentsReducer from './paginationSentInicidentsSlice';

import loadingReducer from './loadingSlice.jsx';
import userDefaultReducer from './userDefaultSlice.jsx';

const rootReducer = combineReducers({
  shippingPdfPrices: shippingPdfPricesReducer,
  loginUser: loginReducer,
  loadError: errorReducer, 
  formatDIUser:formatDIReducer, 
  filtersPurchaseDelivery: filtersPurchaseDeliveryReducer,
  filtersPurchaseSignature: filtersPurchaseSignatureReducer,
  filtersTickets: filtersTicketsReducer,
  filtersVehicles: filtersVehiclesReducer,
  filtersVehiclesTrailers: filtersVehiclesTrailersReducer,
  filtersStores: filtersStoresReducer,
  filtersArticles: filtersArticlesReducer,
  filtersEmployees: filtersEmployeesReducer,
  filtersDrivers: filtersDriversReducer,
  filtersShippings: filtersShippingsReducer,
  filtersRegisters: filtersRegistersReducer,
  filtersContracts: filtersContractsReducer, 
  filtersNTs: filtersCNTReducer,
  filtersSHEET: filtersSHEETReducer,
  filtersFormDI: filtersFormDIReducer,
  filtersReceivedEmails: filtersReceivedEmailsReducer,
  filtersSentEmails: filtersSentEmailsReducer,
  filtersSentIncidents: filtersSentInicidentssReducer,

  pagination: paginationPurchaseDeliveryReducer,
  paginationSignature: paginationSignatureReducer,
  paginationTickets: paginationTicketsReducer,
  paginationVehicles: paginationVehiclesReducer,
  paginationVehiclesTrailers: paginationVehiclesTrailersReducer,
  paginationStores: paginationStoresReducer,
  paginationArticles: paginationArticlesReducer,
  paginationEmployees: paginationEmployeesReducer,
  paginationDrivers: paginationDriversReducer,
  paginationShippings: paginationShippingsReducer,
  paginationRegisters: paginationRegistersReducer,
  paginationContracts: paginationContractsReducer,
  paginationNTs: paginationCNTReducer,
  paginationSHEET: paginationSHEETReducer,
  paginationFormDI: paginationFormDIReducer,
  paginationReceivedEmails: paginationReceivedEmailsReducer,
  paginationSentEmails: paginationSentEmailsReducer,
  paginationSentIncidents: paginationSentIncidentsReducer,

  loading: loadingReducer,
  userDefault: userDefaultReducer
  
});

export default rootReducer;
